import React from 'react';
import useReviews from '../../hooks/useReviews';
import ReviewCart from '../ReviewCart/ReviewCart';

const Reviews = () => {
        const [reviews] = useReviews();
        return (
                <div className="brand-bg mt-5 pt-5 pb-5">
                        <div className="container">
                                <h3 className="brand-color text-center mt-5">See, What Our Customer Say!</h3>
                                <div className="row row-cols-1 row-cols-md-3 g-4 mt-5">
                                        {
                                                reviews.length === 0 ?
                                                        <img className="img-fluid w-25 rounded-3 mx-auto" src="https://trails.ca/wp-content/uploads/2020/10/loading-spinner.gif" alt="" />
                                                        :
                                                        reviews.map(review => <ReviewCart
                                                                key={review.id}
                                                                review={review}
                                                        ></ReviewCart>)
                                        }
                                </div>
                        </div>
                </div>
        );
};

export default Reviews;